// extracted by mini-css-extract-plugin
module.exports = {"list":"ExternalUser_list__3jYwu","label":"ExternalUser_label__1s5n4","name":"ExternalUser_name__bzoZ7","action":"ExternalUser_action__12tAO"};